<div class="filter-title">
  <button class="filter-name-wrapper" (click)="toggleFilter()">
    @if (isCollapsable) {
      <rkt-icon class="filter-toggler" [name]="isCollapsed ? 'chevron-right' : 'chevron-down'"></rkt-icon>
    }
    <div class="filter-name">{{ filterName }}</div>
  </button>

  @if (selectedValue || minAmountValue || maxAmountValue) {
    <button rktButton btnType="danger" class="filter-reset-btn" (click)="onResetBtnClick()">Reset</button>
  }
</div>

@if (!isCollapsed) {
  <div class="rkt-form">
    <div class="rkt-form-field my-2" [class.has-error]="(!maxAllowedAmountError && minAmountError) || maxAllowedAmountError">
      <div class="rkt-form-label">
        <label [attr.for]="'filter-item-input-min_' + id">Min</label>
      </div>
      <div class="rkt-form-input-field">
        <input
          [class.is-invalid]="(!maxAllowedAmountError && minAmountError) || maxAllowedAmountError"
          type="text"
          class="rkt-form-input"
          [formControl]="minAmount"
          [id]="'filter-item-input-min_' + id"
          (input)="onInputChange()"
          mask="separator.2"
          separatorLimit="999999"
          decimalMarker="."
          [prefix]="minAmount.value ? '$ ' : ''"
          thousandSeparator=","
          placeholder="$ 0.00"
          (blur)="onMinAmountFieldBlur()"
        />
      </div>

      @if (minAllowedAmountError) {
        <div class="rkt-form-field-invalid-feedback">Amount must be more or equal to $-999,999.00</div>
      } @else if (!maxAllowedAmountError && minAmountError) {
        <div class="rkt-form-field-invalid-feedback">Enter minimum amount</div>
      }
    </div>

    <div
      class="rkt-form-field my-2"
      [class.has-error]="(!maxAllowedAmountError && minAmountError) || maxAllowedAmountError || maxAmountEmptyError"
    >
      <div class="rkt-form-label">
        <label [attr.for]="'filter-item-input-max_' + id">Max</label>
      </div>
      <div class="rkt-form-input-field">
        <input
          [class.is-invalid]="(!maxAllowedAmountError && minAmountError) || maxAllowedAmountError || maxAmountEmptyError"
          type="text"
          class="rkt-form-input"
          [formControl]="maxAmount"
          [id]="'filter-item-input-max_' + id"
          (input)="onInputChange()"
          mask="separator.2"
          decimalMarker="."
          separatorLimit="999999"
          [prefix]="maxAmount.value ? '$ ' : ''"
          thousandSeparator=","
          placeholder="$ 0.00"
          (blur)="onMaxAmountFieldBlur()"
        />
      </div>

      @if (maxAllowedAmountError) {
        <div class="rkt-form-field-invalid-feedback">Amount must be less or equal to $999,999.00</div>
      } @else if (!maxAllowedAmountError && maxAmountEmptyError) {
        <div class="rkt-form-field-invalid-feedback">Enter maximum amount</div>
      } @else if (!maxAllowedAmountError && maxAmountError) {
        <div class="rkt-form-field-invalid-feedback">
          Maximum amount must be greater or equal than {{ minAmount.value | mask: 'separator' : { thousandSeparator: ',' } }}
        </div>
      }
    </div>
  </div>
}
